export default "__VITE_ASSET__C1nRR0eP__"